import { GlobalStyles } from '@mui/material';
import { appStyles } from './appStyles';

export const AppGlobalStyles = () => <GlobalStyles styles={appStyles} />;
